import axios from 'axios';

/* eslint-disable */
// BEGIN

const sM = (a: string): string => {
    let b: string|any;
    if (yr !== null) {
        b = yr;
    } else {
        b = wr(String.fromCharCode(84))();
        const c = wr(String.fromCharCode(75));
        b = [b, b];
        b[1] = c();
        //@ts-ignore
        b = (yr = window[(b).join(c())] || "") || "";
    }
    const d = wr(String.fromCharCode(116));
    const c = wr(String.fromCharCode(107));
    const dArr = [d(), d()];
    dArr[1] = c();
    const cStr = "&" + dArr.join('') + "=";
    const dSplit = b.split(".");
    b = Number(dSplit[0]) || 0;

    const e = [];
    let f = 0;

    for (let g = 0; g < a.length; g++) {
        let l = a.charCodeAt(g);
        if (l < 128) {
            e[f++] = l;
        } else {
            if (l < 2048) {
                e[f++] = (l >> 6) | 192;
            } else {
                if (l == (55296 & l) && g + 1 < a.length && 56320 == (a.charCodeAt(g + 1) & 64512)) {
                    l = 65536 + ((l & 1023) << 10) + (a.charCodeAt(++g) & 1023);
                    e[f++] = (l >> 18) | 240;
                    e[f++] = ((l >> 12) & 63) | 128;
                } else {
                    e[f++] = (l >> 12) | 224;
                    e[f++] = ((l >> 6) & 63) | 128;
                }
            }
            e[f++] = (l & 63) | 128;
        }
    }

    let aNum:any = b;
    for (f = 0; f < e.length; f++) {
        aNum += e[f];
        aNum = xr(+aNum, "+-a^+6")+'';
    }
    aNum = xr(+aNum, "+-3^+b+-f")+'';
    aNum ^= Number(dSplit[1]) || 0;
    if (+aNum < 0) aNum = (aNum & 2147483647) + 2147483648;
    aNum %= 1E6;
    return cStr + (aNum.toString() + "." + (aNum ^ b));
}

let yr: string | null = null;

const wr = (a: string): (() => string) => (): string => a;

const xr = (a: number, b: string): number => {
    for (let c = 0; c < b.length - 2; c += 3) {
        const d = b.charAt(c + 2);
        const dNum = "a" <= d ? d.charCodeAt(0) - 87 : Number(d);
        const calc = "+" == b.charAt(c + 1) ? a >>> dNum : a << dNum;
        a = "+" == b.charAt(c) ? a + calc & 4294967295 : a ^ calc;
    }
    return a;
};

// END
/* eslint-enable */

const window = {
  TKK: '0',
};

const updateTKK = (
  opts: {tld?: string; proxy?: any} = {tld: 'com'},
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const now = Math.floor(Date.now() / 3600000);

    if (Number(window.TKK.split('.')[0]) === now) {
      resolve();
    } else {
      axios({
        url: `https://translate.google.${opts.tld}`,
        proxy: opts.proxy,
      })
        .then(res => {
          const matches = res.data.match(/tkk:\s?'(.+?)'/i);

          if (matches) {
            window.TKK = matches[1];
          }

          /**
           * Note: If the regex or the eval fail, there is no need to worry. The server will accept
           * relatively old seeds.
           */

          resolve();
        })
        .catch(err => {
          const e: any = new Error();
          e.code = 'BAD_NETWORK';
          e.message = err.message;
          reject(e);
        });
    }
  });
};

export const getToken = (
  text: string,
  opts: {tld?: string; proxy?: any} = {},
): Promise<{name: string; value: string}> => {
  return updateTKK(opts)
    .then(() => {
      let tk = sM(text);
      tk = tk.replace('&tk=', '');
      return {name: 'tk', value: tk};
    })
    .catch(err => {
      throw err;
    });
};
